import { createContext } from 'react';

const FavoritesContext = createContext({
    ids: new Set(),
    has: () => false,
    toggle: () => {},
    reload: () => {},
});

export default FavoritesContext;
